$(document)
  .on('click', '.panel-default .panel-heading', function() {
    setTimeout(function() {
      if( document.querySelector('.panel-default .panel-collapse.collapse.in') ) {
        document.querySelector('.bookings-cnt-text').classList.remove('hide')
      } else {
        document.querySelector('.bookings-cnt-text').classList.add('hide')
      }
    }, 500)
  })
